// v2.0, updated 2025-05-14
import GlobalData from "./GlobalData";
import OpenAirTableStructure from "./OpenAirTableStructure";
import { OA_OBJECTS } from "./ObjectDefinitions";

import emailjs from "emailjs-com";
import AWS from "aws-sdk";

class JNSTools {
  static async fetchGetRest(urlString, creds) {
    const accessToken = await this.refreshSPPToken(creds);
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };

    const response = await fetch(urlString, requestOptions);
    const responseData = await response.text();
    console.log("\nin JNSTools, responseData: " + JSON.stringify(responseData));

    return JSON.parse(responseData);
  }

  static async fetchPostRest(urlString, creds, options) {
    const accessToken = await this.refreshSPPToken(creds);
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    };

    const response = await fetch(urlString, requestOptions);
    const responseData = await response.text();
    console.log("\nin JNSTools, responseData: " + JSON.stringify(responseData));

    return JSON.parse(responseData);
  }

  static async refreshSPPToken(creds) {
    const url = this.getInstanceUrl(creds);
    const newUrl = url.replace("api.pl", "login/oauth2/v1/token");
    const authString = this.getXmlBodyAuthString(creds);

    const requestString =
      authString +
      '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>' +
      creds.company +
      "</group_name><name>collab_center_rest_refresh_token</name></Preference></Read></request>";

    const sppAuthResponse = await this.fetchPost(
      requestString,
      url,
      "Preference",
    );
    const sppAuthResponseArray = this.xmlToArray(sppAuthResponse.xml);
    if (sppAuthResponseArray.length > 0) {
      const cidRequestString =
        authString +
        '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>' +
        creds.company +
        "</group_name><name>rest_cid</name></Preference></Read></request>";

      const sppCidResponse = await this.fetchPost(
        cidRequestString,
        url,
        "Preference",
      );
      const sppCidResponseArray = this.xmlToArray(sppCidResponse.xml);
      if (sppCidResponseArray.length > 0) {
        const csecRequestString =
          authString +
          '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>' +
          creds.company +
          "</group_name><name>rest_csec</name></Preference></Read></request>";

        const sppCsecResponse = await this.fetchPost(
          csecRequestString,
          url,
          "Preference",
        );
        const sppCsecResponseArray = this.xmlToArray(sppCsecResponse.xml);
        if (sppCsecResponseArray.length > 0) {
          const cid = sppCidResponseArray[0].setting;
          const csec = sppCsecResponseArray[0].setting;
          const basicToken = btoa(cid + ":" + csec);

          const authObject = {
            grant_type: "refresh_token",
            refresh_token: sppAuthResponseArray[0].setting,

            //refresh_token:
            //"bmdMRHdkblVwUUhIRGJaSjhnNXN5UjBqUkhLdERhK1M1SlQvRi84cFZ3YmdHalY1VGdyeHcrU3JQdXdSRnZGT2lzSjJlUEpubE5TdWZHL05jclVLMFVicF83NTcyNA",
            redirect_uri: "https://oauth.pstmn.io/v1/browser-callback",
            client_id: cid,
            client_secret: csec,
          };

          const authHeaders = {
            Authorization: "Basic " + basicToken,
            "Content-Type": "application/x-www-form-urlencoded",
          };

          const optionString = new URLSearchParams(authObject).toString();

          const authOptions = {
            method: "POST",
            headers: authHeaders,
            body: optionString,
          };

          const authResponse = await fetch(newUrl, authOptions);
          const responseData = await authResponse.json();

          console.log("ACCESS TOKEN: " + responseData.access_token);
          const access_token = this.encrypt(responseData.access_token);
          sessionStorage.setItem("resttoken", access_token);

          const refresh_token = responseData.refresh_token;

          if (sppAuthResponseArray.length === 0) {
            const createPrefRecordString =
              authString +
              '<Add type="Preference"><Preference><group_name>' +
              creds.company +
              "</group_name><name>collab_center_rest_refresh_token</name><setting>" +
              refresh_token +
              "</setting></Preference></Add></request>";

            this.fetchPost(createPrefRecordString, url);
          } else {
            const modifyPrefRecordString =
              authString +
              '<Modify type="Preference"><Preference><id>' +
              sppAuthResponseArray[0].id +
              "</id><setting>" +
              refresh_token +
              "</setting></Preference></Modify></request>";
            this.fetchPost(modifyPrefRecordString, url);
          }

          return responseData.access_token;
        }
      }
    }
  }
  static currencyFormatter(field, data, column) {
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(data[field]);
    return formatted;
  }

  static currencyFormatterNoDecimal(field, data, column) {
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(data[field]);
    return formatted.substring(0, formatted.length - 3);
  }
  static getXmlBodyAuthString(creds) {
    if (creds.company == "Genericomp") {
      creds.company = "Leanswift Solutions Inc";
    }
    let xmlBody = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';

    if (creds.instanceType == "Production") {
      xmlBody +=
        '<request API_version = "1.0" client = "RW Manager" client_ver = "1.0" namespace = "default" key = "3lznsNJvAwp2xkBcf2Yo">';
    } else {
      xmlBody +=
        '<request API_version = "1.0" client = "RW Manager" client_ver = "1.0" namespace = "default" key = "bmFxjoQEjAK3AAeAavqL">';
    }
    if (creds.userType == "generic") {
      const adminCredsString = localStorage.getItem("adminCreds");

      const adminCreds =
        adminCredsString.indexOf("company") == -1
          ? JSON.parse(this.decrypt(localStorage.getItem("adminCreds")))
          : JSON.parse(adminCredsString);

      xmlBody +=
        "<Auth><Login><company>" +
        adminCreds.company +
        "</company><user>" +
        adminCreds.username +
        "</user><password>" +
        adminCreds.password +
        "</password></Login></Auth>";
    } else {
      xmlBody +=
        "<Auth><Login><company>" +
        creds.company +
        "</company><user>" +
        creds.username +
        "</user><password>" +
        creds.password +
        "</password></Login></Auth>";
    }
    return xmlBody;
  }
  static getXmlBodyRemoteAuthString(creds) {
    let xmlBody = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';

    if (creds.instanceType == "Production") {
      xmlBody +=
        '<request API_version = "1.0" client = "RW Manager" client_ver = "1.0" namespace = "default" key = "3lznsNJvAwp2xkBcf2Yo">';
    } else {
      xmlBody +=
        '<request API_version = "1.0" client = "RW Manager" client_ver = "1.0" namespace = "default" key = "bmFxjoQEjAK3AAeAavqL">';
    }
    if (creds.userType == "generic") {
      const adminCredsString = localStorage.getItem("adminCreds");

      const adminCreds =
        adminCredsString.indexOf("company") == -1
          ? JSON.parse(this.decrypt(localStorage.getItem("adminCreds")))
          : JSON.parse(adminCredsString);

      xmlBody +=
        "<RemoteAuth><Login><company>" +
        adminCreds.company +
        "</company><user>" +
        adminCreds.username +
        "</user><password>" +
        adminCreds.password +
        "</password></Login></RemoteAuth>";
    } else {
      xmlBody +=
        "<RemoteAuth><Login><company>" +
        creds.company +
        "</company><user>" +
        creds.username +
        "</user><password>" +
        creds.password +
        "</password></Login></RemoteAuth>";
    }

    //const response = await this.fetchPost(xmlBody, this.getInstanceUrl(creds));
    //console.log("response");

    return xmlBody;
  }
  static getInstanceUrl(creds) {
    let urlString = "https://secret-sierra-62981.herokuapp.com/https://";
    let companyName =
      creds.company == "Genericomp" ? "Leanswift Solutions Inc" : creds.company;
    companyName = companyName.toLowerCase().replace(/[^a-z^0-9^ ]/g, "");
    companyName = companyName.replace(/[ ]/g, "-");
    if (creds.instanceType == "Production") {
      urlString += companyName + ".app.openair.com/api.pl";
    } else {
      urlString +=
        companyName + ".app.sandbox.netsuitesuiteprojectspro.com/api.pl";
    }
    //console.log("(JNSTools) urlString: " + urlString);

    return urlString;
  }
  static CSVParse(csvString, reviver) {
    reviver =
      reviver ||
      function (r, c, v) {
        return v;
      };
    var chars = csvString.split(""),
      c = 0,
      cc = chars.length,
      start,
      end,
      table = [],
      row;
    while (c < cc) {
      table.push((row = []));
      while (c < cc && "\r" !== chars[c] && "\n" !== chars[c]) {
        start = end = c;
        if ('"' === chars[c]) {
          start = end = ++c;
          while (c < cc) {
            if ('"' === chars[c]) {
              if ('"' !== chars[c + 1]) {
                break;
              } else {
                chars[++c] = ""; // unescape ""
              }
            }
            end = ++c;
          }
          if ('"' === chars[c]) {
            ++c;
          }
          while (
            c < cc &&
            "\r" !== chars[c] &&
            "\n" !== chars[c] &&
            "," !== chars[c]
          ) {
            ++c;
          }
        } else {
          while (
            c < cc &&
            "\r" !== chars[c] &&
            "\n" !== chars[c] &&
            "," !== chars[c]
          ) {
            end = ++c;
          }
        }
        row.push(
          reviver(
            table.length - 1,
            row.length,
            chars.slice(start, end).join(""),
          ),
        );
        if ("," === chars[c]) {
          ++c;
        }
      }
      if ("\r" === chars[c]) {
        ++c;
      }
      if ("\n" === chars[c]) {
        ++c;
      }
    }

    return table;
  }
  static fixFormat(dateStr) {
    var newDateStr = "";
    var delim = "-";
    //console.log("dateStr: " + dateStr + "  dateStrlength: " + dateStr.length);
    if (dateStr.length != 10) {
      var dashDelim = dateStr.indexOf("-");
      if (dashDelim == -1) {
        delim = "/";
      }
      var firstDelimIndex = dateStr.indexOf(delim);
      var secondDelimIndex = dateStr.indexOf(delim, firstDelimIndex + 1);

      var firstPart = dateStr.substring(0, firstDelimIndex);
      if (delim == "-") {
        if (firstPart.length != 4) {
          firstPart = "20" + firstPart;
        }
      } else {
        if (firstPart.length != 2) {
          firstPart = "0" + firstPart;
        }
      }

      var secondPart = dateStr.substring(firstDelimIndex + 1, secondDelimIndex);
      if (secondPart.length != 2) {
        secondPart = "0" + secondPart;
      }
      var thirdPart = dateStr.substr(secondDelimIndex + 1);
      if (delim == "-") {
        if (thirdPart.length != 2) {
          thirdPart = "0" + thirdPart;
        }
      } else {
        if (thirdPart.length != 4) {
          thirdPart = "20" + thirdPart;
        }
      }

      newDateStr = firstPart + delim + secondPart + delim + thirdPart + delim;
      //console.log("dateStr: " + dateStr + "  firstDelim: " + firstDelimIndex +"  secondDelim: " + secondDelimIndex + "  first: " + firstPart + "  second: " + secondPart + "  third: " + thirdPart,);
    } else {
      newDateStr = dateStr;
    }

    return newDateStr;
  }
  static async fetchGet(urlString, auth) {
    console.log("\nin JNSTools, GET urlString: " + urlString);
    const requestOptions = {
      method: "GET",
      headers: {
        //Authorization: "Basic dG9wIHN0ZXAgc2FuZGJveFxqc2NoZWluOlRvcHN0ZXAx",
        Authorization: auth,
      },
    };

    const response = await fetch(urlString, requestOptions);
    const responseData = await response.text();
    console.log("\nin JNSTools, responseData: " + JSON.stringify(responseData));

    return JSON.parse(responseData);
  }

  static sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static async fetchPost(requestString, urlString, tag) {
    const requestId = new Date().getTime();
    await this.sleep(10);

    const loggableRequestString = requestString.replace(
      /<password>.*<\/password>/,
      "PASSWORD",
    );
    console.log(
      "\nREQUEST ID: " +
        requestId +
        ", " +
        new Date().toLocaleString() +
        ", requestString: " +
        loggableRequestString,
    );
    let returnObject = null;
    let sessionId;
    let endOfAuth = requestString.indexOf("</RemoteAuth>");
    if (endOfAuth >= 0) {
      const remoteAuthRequestString =
        requestString.substring(0, endOfAuth + 13) + "</request>";
      const remoteAuthRequestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/xml" },
        body: remoteAuthRequestString,
      };
      const storedSessionId = sessionStorage.getItem("sessionId");
      if (!storedSessionId) {
        const remoteAuthResponse = await fetch(
          urlString,
          remoteAuthRequestOptions,
        );
        const remoteAuthResponseData = await remoteAuthResponse.text();
        const remoteAuthParser = new DOMParser();
        const remoteAuthXml = remoteAuthParser.parseFromString(
          remoteAuthResponseData,
          "text/xml",
        );

        const sessionString =
          remoteAuthXml.childNodes[0].childNodes[0].textContent;
        const uidPos = sessionString.indexOf("uid=") + 4;
        sessionId = sessionString.substring(
          uidPos,
          sessionString.indexOf(";", uidPos),
        );
        sessionStorage.setItem("sessionId", sessionId);
      } else {
        sessionId = storedSessionId;
      }
      requestString = requestString.replace(/RemoteAuth/g, "Auth");

      requestString = requestString.replace(
        /<uid><\/uid>/,
        "<uid>" + sessionId + "</uid>",
      );
    }

    //requestString = requestString.replace(/(\r\n|\r|\n)/g, "");
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/xml" },
      body: requestString,
    };

    const response = await fetch(urlString, requestOptions);
    const responseData = await response.text();
    console.log(
      "\nRESPONSE ID: " +
        requestId +
        ", " +
        new Date().toLocaleString() +
        ",responseData: " +
        JSON.stringify(responseData),
    );

    if (tag != "NOXML") {
      const parser = new DOMParser();
      const xml = parser.parseFromString(responseData, "text/xml");

      const authStatus =
        xml.childNodes[0].childNodes[0].attributes[0].textContent; // first childNodes[0] = <request> node, second childNodes[0] = <Auth> node

      // remote auth url with session ID = xml.childNodes[0].childNodes[0].textContent; localName

      const childNodes = Array.from(xml.childNodes[0].childNodes);
      const postStatus = childNodes.slice(1).map((value) => {
        // slice(1) removes the Auth node from this mapping
        return parseInt(value.attributes[0].textContent);
      });

      let returnXml = null;
      //if (authStatus == "0" && postStatus == "0") {
      if (authStatus == "0") {
        if (tag) {
          //const responseNodes = xml.querySelectorAll(tag);
          returnXml = xml.querySelectorAll(tag);
        } else {
          returnXml = xml;
        }
      } else {
        console.log(
          "in JNSTools, authStatus: " +
            authStatus +
            "  postStatus: " +
            JSON.stringify(postStatus),
        );
        //alert("auth failure: " + authStatus);
      }

      let postAlerts = [];
      let moreErrors = 0;
      postStatus.forEach((elem) => {
        if (elem !== 0 && elem !== 601 && elem !== 401) {
          if (postAlerts.length < 10) {
            postAlerts.push(elem);
          } else {
            moreErrors++;
          }
        }
      });
      if (moreErrors > 0) {
        postAlerts.push("+ " + moreErrors + " more");
      }

      if (postAlerts.length > 0) {
        if (postAlerts[0] != 2) {
          // don't alert on invalid login
          alert(
            "Collab Center has encountered the following SuiteProjects Pro errors:\n " +
              JSON.stringify(postAlerts),
          );
        }
      }
      returnObject = {
        authStatus: authStatus,
        postStatus: postStatus,
        xml: returnXml,
        uid: sessionId,
      };
    }
    return returnObject;

    //console.log("in JNSTools, responseNodes length: " + responseNodes.length);
    //return responseNodes;
  }
  static objArrayFind(objArray, testObj, indexOnly) {
    var returnObj;

    var paramList = [];
    var valueList = [];
    var x;
    for (x in testObj) {
      if (testObj[x] !== undefined) {
        paramList.push(x);
        valueList.push(testObj[x]);
      }
    }

    var i = 0;
    var foundObj = false;
    while (i < objArray.length && foundObj === false) {
      var matchCounter = 0;
      for (var j = 0; j < paramList.length; j++) {
        if (objArray[i][paramList[j]] == valueList[j]) {
          matchCounter++;
        }
      }
      if (matchCounter == paramList.length) {
        foundObj = true;
        returnObj = objArray[i];
        if (indexOnly) {
          returnObj = i;
        }
      }
      i++;
    }
    return returnObj;
  }
  static objArrayFilter(objArray, testObj) {
    var returnArray = [];

    var paramList = [];
    var valueList = [];
    var x;
    for (x in testObj) {
      if (testObj[x] !== undefined) {
        paramList.push(x);
        valueList.push(testObj[x]);
      }
    }

    for (var i = 0; i < objArray.length; i++) {
      for (var j = 0; j < paramList.length; j++) {
        if (objArray[i][paramList[j]] == valueList[j]) {
          returnArray.push(objArray[i]);
        }
      }
    }
    return returnArray;
  }
  static parseDateString(dateStr) {
    let newDateStr =
      "<Date><year>0000</year><month>00</month><day>00</day><hour>00</hour><minute>00</minute><second>00</second></Date>";

    if (dateStr) {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(5, 7);
      const day = dateStr.substring(8);
      newDateStr =
        "<Date><year>" +
        year +
        "</year><month>" +
        month +
        "</month><day>" +
        day +
        "</day></Date>";
    }
    return newDateStr;
  }
  static parseDateObject(dateObj) {
    let emptyDate = false;
    if (typeof dateObj != "object" || !dateObj) {
      emptyDate = true;
    }
    let returnString = "<Date>";
    let newMonth;
    if (!emptyDate) {
      newMonth = dateObj.getMonth() + 1;

      returnString += "<year>" + dateObj.getFullYear() + "</year>";
      returnString += "<month>" + newMonth + "</month>";
      returnString += "<day>" + dateObj.getDate() + "</day>";
      returnString += "<hour>" + dateObj.getHours() + "</hour>";
      returnString += "<minute>" + dateObj.getMinutes() + "</minute>";
      returnString += "<second>" + dateObj.getSeconds() + "</second>";
      returnString += "</Date>";
    } else {
      returnString +=
        "<year>0000</year><month>00</month><day>00</day><hour>00</hour><minute>00</minute><second>00</second></Date>";
    }
    return returnString;
  }
  static unpackDate(dateStr) {
    const year = dateStr.substring(
      dateStr.indexOf("<year>") + 6,
      dateStr.indexOf("</year>"),
    );
    let month = dateStr.substring(
      dateStr.indexOf("<month>") + 7,
      dateStr.indexOf("</month"),
    );
    if (month.length == 1) {
      month = "0" + month;
    }
    let day = dateStr.substring(
      dateStr.indexOf("<day>") + 5,
      dateStr.indexOf("</day>"),
    );
    if (day.length == 1) {
      day = "0" + day;
    }

    const returnString = year + "-" + month + "-" + day;

    return returnString;
  }
  static storageAvailable(type) {
    let storage;
    try {
      storage = window[type];
      const x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === "QuotaExceededError" ||
          // Firefox
          e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      );
    }
  }
  static async populateGlobalData(selectedTable, creds) {
    return new Promise((resolve) => {
      let globalData = {};

      const tableStructureObject = new OpenAirTableStructure(
        selectedTable,
        creds,
      );
      const globalDataObject = new GlobalData(creds);
      const tableMatchFunction = (oaObj) => oaObj.name == selectedTable;
      // find ObjectDefinition for currently selected table
      const tableDef = OA_OBJECTS.find(tableMatchFunction);
      const dropdownLength = tableDef.dropdownFields.length;
      let dropdownCounter = 0;

      tableStructureObject.getTableData().then((val) => {
        if (val) {
          //fieldArray.current = val.stand.concat(val.cust);

          // for each dropdown field on that object
          if (dropdownLength > 0) {
            tableDef.dropdownFields.forEach((dropdownField) => {
              const refFieldMatchFunction = (oaObj) =>
                oaObj.referenceFields.indexOf(dropdownField) > -1;
              // find ObjectDefinition where the dropdown field on the selected table matches one of the reference fields on the object definition
              const refTableObject = OA_OBJECTS.find(refFieldMatchFunction);
              const tableToPopulate = refTableObject.name;

              globalDataObject
                .populateTable(tableToPopulate)
                .then((returnArray) => {
                  (globalData = {
                    ...globalData,
                    [tableToPopulate]: returnArray,
                  }),
                    dropdownCounter++;
                  if (dropdownCounter == dropdownLength) {
                    resolve(globalData);
                  }
                });
            });
          } else {
            console.log(
              "(DataViewScreenHeader) No dropdowns, resolving to empty object",
            );
            resolve(globalData);
          }
        } else {
          console.log(
            "(DataViewScreenHeader) No table data, resolving to null",
          );
          resolve(null);
        }
      });
    });
  }
  static sendMail(templateParams) {
    console.log("templateParams: " + JSON.stringify(templateParams));
    emailjs.send(
      "service_oada",
      "template_46adfi7",
      templateParams,
      "2FHJMHf8TQu-Ag783",
    );
  }
  static xmlToArray(xmlObject) {
    let recordArray = [];

    for (let i = 0; i < xmlObject.length; i++) {
      let recordObject = {};
      for (const entry of xmlObject[i].childNodes.entries()) {
        const fieldName = entry[1].nodeName;
        const node = xmlObject[i].childNodes[entry[0]];

        // Check if this is a Date node with nested year/month/day structure
        let fieldValue;
        if (
          node.childNodes.length > 0 &&
          node.querySelector("year, month, day")
        ) {
          // Parse nested date structure to MMddyyyy format
          const year = node.querySelector("year")?.textContent || "";
          const month = node.querySelector("month")?.textContent || "";
          const day = node.querySelector("day")?.textContent || "";

          if (year && month && day) {
            // Format as MMddyyyy (pad month and day with leading zeros if needed)
            fieldValue = month.padStart(2, "0") + day.padStart(2, "0") + year;
          } else {
            fieldValue = node.textContent;
          }
        } else {
          fieldValue = node.textContent;
        }

        recordObject = { ...recordObject, [fieldName]: fieldValue };
      }
      recordArray.push(recordObject);
      // at this point recordArray is an array of recordObjects, which are name-value pairs for each field on the record
    }

    return recordArray;
  }
  static writeSettings(creds, projId) {
    //const userInfo = JSON.parse(localStorage.getItem(creds.company + "|User"));
    //const userId = userInfo.find((elem) => elem.nickname == creds.username).id;
    const INSTANCE_OADA_SETTINGS = [
      "riskCategoryDropdown_options",
      "actionCategoryDropdown_options",
      "assumptionCategoryDropdown_options",
      "issueCategoryDropdown_options",
      "decisionCategoryDropdown_options",
      "requirementCategoryDropdown_options",
      "storageOption",
      "openStageDropdown_options",
      "assignedStageDropdown_options",
      "pendingStageDropdown_options",
      "resolvedStageDropdown_options",
      "decisionNeededStageDropdown_options",
      "decisionMadeStageDropdown_options",
      "requirementVersionsCategoryDropdown_options",
      "approvedRequirementStageDropdown_options",
      "proposedRequirementStageDropdown_options",
      "highSeverityDropdown_options",
      "mediumSeverityDropdown_options",
      "lowSeverityDropdown_options",
    ];

    const PROJECT_OADA_SETTINGS = [
      "thresholds",
      "showFinancialsExternal",
      "ganttDateSource",
      "ganttDateEditing",
      "ganttSource",
      "etcCalcOption",
      "reqCategories",
      "raidStageFilterSettings_risk",
      "raidStageFilterSettings_action",
      "raidStageFilterSettings_assumption",
      "raidStageFilterSettings_issue",
      "raidStageFilterSettings_decision",
      "raidSeverityFilterSettings_risk",
      "raidSeverityFilterSettings_action",
      "raidSeverityFilterSettings_assumption",
      "raidSeverityFilterSettings_issue",
      "raidSeverityFilterSettings_decision",
    ];

    const USER_OADA_SETTINGS = [
      "changeLogCheckboxSettingsTasks",
      "changeLogCheckboxSettingsReqs",
      "changeLogCheckboxSettingsIssues",
      "startingDashboardScreen",
      "lastProjectRefresh",
      "associatedClient",
    ];

    const userId = creds.id;
    const authString = this.getXmlBodyAuthString(creds);
    const urlString = this.getInstanceUrl(creds);

    let instancePrefRecords = [];
    let projectPrefRecords = [];
    let userPrefRecords = [];

    const readInstancePrefString =
      authString +
      '<Read type="Preference" method="equal to" limit="1000"><Preference><group_name>oadaSettings</group_name><userid>-1</userid></Preference></Read></request>';

    this.fetchPost(readInstancePrefString, urlString, "Preference").then(
      (instancePrefRecordXML) => {
        if (instancePrefRecordXML.xml.length > 0) {
          instancePrefRecords = this.xmlToArray(instancePrefRecordXML.xml);
        }

        const readProjectPrefString =
          authString +
          '<Read type="Preference" method="equal to" limit="1000"><Preference><group_name>oadaProjectSettings</group_name><userid>' +
          projId +
          "</userid></Preference></Read></request>";

        this.fetchPost(readProjectPrefString, urlString, "Preference").then(
          (projectPrefRecordXML) => {
            if (projectPrefRecordXML.xml.length > 0) {
              projectPrefRecords = this.xmlToArray(projectPrefRecordXML.xml);
            }

            const readUserPrefString =
              authString +
              '<Read type="Preference" method="equal to" limit="1000"><Preference><group_name>oadaProjectSettings</group_name><userid>' +
              creds.id +
              "</userid></Preference></Read></request>";

            this.fetchPost(readUserPrefString, urlString, "Preference").then(
              (userPrefRecordXML) => {
                if (userPrefRecordXML.xml.length > 0) {
                  userPrefRecords = this.xmlToArray(userPrefRecordXML.xml);
                }

                const prefRecords = instancePrefRecords.concat(
                  projectPrefRecords.concat(userPrefRecords),
                );

                let modString = "";
                let addString = "";
                //let userClient = creds.client;
                const localSettingsString =
                  localStorage.getItem("oadaSettings");
                if (localSettingsString) {
                  const localSettings = JSON.parse(localSettingsString);
                  Object.entries(localSettings).forEach((settingPair) => {
                    const key = settingPair[0];
                    const origValue = settingPair[1];
                    const value =
                      typeof origValue == "string"
                        ? origValue
                        : JSON.stringify(origValue);

                    if (INSTANCE_OADA_SETTINGS.indexOf(key) >= 0) {
                      const foundRec = prefRecords.find(
                        (elem) => elem.name == key,
                      );
                      if (foundRec) {
                        modString +=
                          '<Modify type="Preference"><Preference><id>' +
                          foundRec.id +
                          "</id><setting>" +
                          value +
                          "</setting></Preference></Modify>";
                      } else {
                        addString +=
                          '<Add type="Preference"><Preference><group_name>oadaSettings</group_name><userid>-1</userid><name>' +
                          key +
                          "</name><setting>" +
                          value +
                          "</setting></Preference></Add>";
                      }
                    } else if (PROJECT_OADA_SETTINGS.indexOf(key) >= 0) {
                      // putting project id into userid field, OA allows it
                      const foundRec = prefRecords.find(
                        (elem) => elem.name == key && elem.userid == projId,
                      );
                      if (foundRec) {
                        modString +=
                          '<Modify type="Preference"><Preference><id>' +
                          foundRec.id +
                          "</id><setting>" +
                          value +
                          "</setting></Preference></Modify>";
                      } else {
                        addString +=
                          '<Add type="Preference"><Preference><userid>' +
                          projId +
                          "</userid><group_name>oadaProjectSettings</group_name><name>" +
                          key +
                          "</name><setting>" +
                          value +
                          "</setting></Preference></Add>";
                      }
                    } else if (USER_OADA_SETTINGS.indexOf(key) >= 0) {
                      const foundRec = prefRecords.find(
                        (elem) => elem.name == key && elem.userid == userId,
                      );
                      if (foundRec) {
                        modString +=
                          '<Modify type="Preference"><Preference><id>' +
                          foundRec.id +
                          "</id><setting>" +
                          value +
                          "</setting></Preference></Modify>";
                      } else {
                        addString +=
                          '<Add type="Preference"><Preference><userid>' +
                          userId +
                          "</userid><group_name>oadaSettings</group_name><name>" +
                          key +
                          "</name><setting>" +
                          value +
                          "</setting></Preference></Add>";
                      }
                    } else {
                      console.log("MISSING SETTING: " + key);
                    }
                  });
                  console.log("mod: " + modString);
                  console.log("add: " + addString);
                  if (modString) {
                    this.fetchPost(
                      authString + modString + "</request>",
                      urlString,
                    );
                  }
                  if (addString) {
                    this.fetchPost(
                      authString + addString + "</request>",
                      urlString,
                    );
                  }
                }
              },
            );
          },
        );
      },
    );

    //this.fetchPost(requestString, this.getInstanceUrl(creds));
  }
  static getGlobalTable(table, creds) {
    const globalDataObject = new GlobalData(creds);
    globalDataObject.populateTable(table, true).then(() => {
      return JSON.parse(localStorage.getItem(creds.company + "|" + table));
    });
  }
  static encodeHTML(htmlString) {
    return String(htmlString)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  static removeTags(htmlString) {
    let text = "";
    if (htmlString !== null && htmlString !== "" && htmlString !== undefined) {
      htmlString = htmlString.toString();
      const endLine = String.fromCharCode(10);
      //const tempText = htmlString.replace(/<\/p>/g, "</p>" + endLine);
      const tempText = htmlString;
      text = tempText.replace(/(<([^>]+)>)/gi, endLine);
      text = text.replace(/(\n)+/g, endLine);
      //text = tempText;
    }
    return text;

    /*let div = document.createElement("div");
    div.innerHTML = htmlString;
    let text = div.textContent || div.innerText || "";
    return text;*/
  }
  static encryptValue(origString) {
    let finalString = origString;
    if (origString.length >= 8) {
      let origBase64 = btoa(origString);
      let iterations = 0;
      while (origBase64.length < 50 && iterations < 50) {
        origBase64 += origBase64;
        iterations++;
      }
      const paddedString1 = origBase64.slice(0, 5) + "W" + origString.slice(5);
      const paddedString2 =
        paddedString1.slice(0, 15) + "u" + paddedString1.slice(15);
      const paddedString3 =
        paddedString2.slice(0, 25) + "m" + paddedString2.slice(25);
      const paddedString4 =
        paddedString3.slice(0, 35) + "b" + paddedString3.slice(35);
      const paddedString5 =
        paddedString4.slice(0, 45) + "o" + paddedString4.slice(45);

      finalString =
        paddedString5.slice(0, 3) + iterations + paddedString5.slice(3);
    }
    return finalString;
  }
  static async getIssueCategory(type, creds) {
    let catId = 0;
    const globalDataObject = new GlobalData(creds);
    globalDataObject.populateTable("IssueCategory").then(() => {
      const issueCategories = JSON.parse(
        localStorage.getItem(creds.company + "|IssueCategory"),
      );
      const catElement = issueCategories.find((elem) => elem.name == type);
      if (catElement) {
        catId = catElement.id;
      } else {
        alert(
          "ERROR: Misisng " +
            type +
            " Category.  If this has been resolved in SuiteProjects Pro, revisiting this page will reflect the change.  Otherwise, please contact your SuiteProjects Pro Administrator.",
        );
        localStorage.removeItem(creds.company + "|IssueCategory");
      }

      return catId;
    });
  }

  static calculateProjectMetrics(projectObject) {
    const settings = JSON.parse(localStorage.getItem("oadaSettings"));
    const finishDateField = settings
      ? settings.projectFinishDateField || "finish_date"
      : "finish_date";

    const etcMethod = settings
      ? settings.etcCalcOption || "budgetTimesRemaining"
      : "budgetTimesRemaining";

    const today = new Date();
    /*const bac =
      parseFloat(projectObject.oada_project_booked_hours__c) > 0
        ? parseFloat(projectObject.oada_project_booked_hours__c)
        : parseFloat(projectObject.budget_time);*/
    const bac = parseFloat(projectObject.budget_time);
    const projStartDate = new Date(
      projectObject.start_date.substring(4, 8) +
        "-" +
        projectObject.start_date.substring(0, 2) +
        "-" +
        projectObject.start_date.substring(2, 4),
    );
    let projEndDate;
    // standard finish date has different format than custom date fields
    if (
      finishDateField == "finish_date" ||
      projectObject[finishDateField].substring(0, 4) == "0000"
    ) {
      projEndDate = new Date(
        projectObject.finish_date.substring(4, 8) +
          "-" +
          projectObject.finish_date.substring(0, 2) +
          "-" +
          projectObject.finish_date.substring(2, 4),
      );
    } else {
      projEndDate = new Date(projectObject[finishDateField]);
    }

    const daysDiffFromToday =
      today > projStartDate ? (today - projStartDate) / 86400000 + 1 : 0;
    let weeksFromToday = (daysDiffFromToday - (daysDiffFromToday % 7)) / 7;
    if (projStartDate.getDay() - today.getDay() > 1) {
      weeksFromToday++;
    }
    const daysIn = daysDiffFromToday - weeksFromToday * 2;

    const daysDiffTotal =
      projEndDate > projStartDate
        ? (projEndDate - projStartDate) / 86400000 + 1
        : 0;
    let weeksTotal = (daysDiffTotal - (daysDiffTotal % 7)) / 7;
    if (projStartDate.getDay() - projEndDate.getDay() > 1) {
      weeksTotal++;
    }
    const duration = daysDiffTotal - weeksTotal * 2;
    const calcPctComplete = daysIn / duration;

    const pv = calcPctComplete * bac;
    const actualPctComplete =
      parseFloat(projectObject.oada_project_pct_complete__c) / 100;
    const ev = actualPctComplete * bac;
    const ac = parseFloat(projectObject.oada_actual_hours__c);
    const cv = ev - ac;
    const sv = ev - pv;
    const cpi = ac > 0 ? ev / ac : 0;
    const spi = pv > 0 ? ev / pv : 0;

    let etc;

    switch (etcMethod) {
      case "plannedMinusActual":
        etc = parseFloat(projectObject.oada_project_planned_hours__c) - ac;
        break;
      case "budgetTimesRemaining":
        etc = parseFloat(projectObject.budget_time) * (1 - actualPctComplete);
        break;
      case "futureBooked":
        //etc = await this.getFutureBookedHours(projectObject.id, creds);
        etc = parseFloat(sessionStorage.getItem("futureBooked"));
        break;
      case "bookedMinusActual":
        etc = parseFloat(projectObject.oada_project_booked_hours__c) - ac;
        break;
      case "evm":
        etc = cpi > 0 ? (bac - ev) / cpi : 0;
        break;
      case "useManual":
        etc = parseFloat(projectObject.oada_etc_hours__c);
        break;
    }

    etc = Math.round(etc * 100) / 100;
    let eac;
    if (etcMethod == "useManual") {
      eac = parseFloat(projectObject.oada_eac_hours__c);
    } else {
      eac = Math.round((ac + etc) * 100) / 100;
    }

    const vac = bac - eac;

    const metrics = {
      daysIn: daysIn,
      duration: duration,
      budgetAtCompletion: bac,
      plannedValue: pv,
      actualPctComplete: actualPctComplete,
      calcPctComplete: calcPctComplete,
      earnedValue: ev,
      actualCost: ac,
      costVariance: cv,
      scheduleVariance: sv,
      schedulePerformanceIndex: spi,
      costPerformanceIndex: cpi,
      estimateToCompletion: etc,
      estimateAtCompletion: eac,
      varianceAtCompletion: vac,
      health: projectObject.oada_project_health__c,
      actualHours: projectObject.oada_actual_hours__c,
      actualMoney: projectObject.oada_actual_money__c,
      eacHours: projectObject.oada_eac_hours__c,
      eacMoney: projectObject.oada_eac_money__c,
      etcHours: projectObject.oada_etc_hours__c,
      etcMoney: projectObject.oada_etc_money__c,
      budgetHours: projectObject.budget_time,
      budgetMoney: projectObject.budget,
    };

    return metrics;
  }
  static async getFutureBookedHours(projId, creds) {
    const today = new Date();
    const authString = this.getXmlBodyAuthString(creds);
    const urlString = this.getInstanceUrl(creds);
    const requestString =
      authString +
      '<Read type="BookingByDay" method="equal to" limit="1000" filter="newer-than" field="date"><BookingByDay><project_id>' +
      projId +
      "</project_id></BookingByDay><Date><year>" +
      today.getFullYear() +
      "</year><month>" +
      parseInt(today.getMonth() + 1) +
      "</month><day>" +
      today.getDate() +
      "</day></Date></Read></request>";

    this.fetchPost(requestString, urlString, "BookingByDay").then((rawbbd) => {
      let hours = 0;
      if (rawbbd.xml.length > 0) {
        const bbdArray = this.xmlToArray(rawbbd.xml);
        for (let i = 0; i < bbdArray.length; i++) {
          hours += parseFloat(bbdArray[i].hours);
        }
      }
      sessionStorage.setItem("futureBooked", hours ? hours : 0);
    });
  }
  static encrypt(text) {
    const key = "0ADA!oada";
    return [...text]
      .map((x, i) =>
        (x.codePointAt() ^ key.charCodeAt(i % key.length) % 255)
          .toString(16)
          .padStart(2, "0"),
      )
      .join("");
  }
  static decrypt(text) {
    const key = "0ADA!oada";
    return String.fromCharCode(
      ...text
        .match(/.{1,2}/g)
        .map((e, i) => parseInt(e, 16) ^ key.charCodeAt(i % key.length) % 255),
    );
  }
  static async getGoogleToken() {
    const urlString = "https://oauth2.googleapis.com/token";
    var authDetails = {
      client_id:
        "582665462168-ikcnvld3fmakc6cdn7ae6av935e4nq8c.apps.googleusercontent.com",
      client_secret: "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",
      grant_type: "refresh_token",
      refresh_token:
        "1//04yfnKNsBoxFuCgYIARAAGAQSNwF-L9Irv2LGhmxbn-8-EqIxTWnRZNHzq8QcXTxLm-gizU5I8uirGrN0F_qjwe-tcNRsuArWYhc",
    };
    const formBody = Object.keys(authDetails)
      .map(
        (key) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(authDetails[key]),
      )
      .join("&");
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: formBody,
    };

    const response = await fetch(urlString, requestOptions);
    const responseData = await response.text();
    const accessTokenIndex = responseData.indexOf("access_token") + 16;
    const expiresInIndex = responseData.indexOf("expires_in") - 6;
    const accessToken = responseData.substring(
      accessTokenIndex,
      expiresInIndex,
    );
    return accessToken;
  }
  static async gDrivePost(file, name, type) {
    const urlString = "https://oauth2.googleapis.com/token";
    var authDetails = {
      client_id:
        "582665462168-ikcnvld3fmakc6cdn7ae6av935e4nq8c.apps.googleusercontent.com",
      client_secret: "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",
      grant_type: "refresh_token",
      refresh_token:
        "1//04yfnKNsBoxFuCgYIARAAGAQSNwF-L9Irv2LGhmxbn-8-EqIxTWnRZNHzq8QcXTxLm-gizU5I8uirGrN0F_qjwe-tcNRsuArWYhc",
    };
    const formBody = Object.keys(authDetails)
      .map(
        (key) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(authDetails[key]),
      )
      .join("&");
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: formBody,
    };

    const response = await fetch(urlString, requestOptions);
    const responseData = await response.text();
    const accessTokenIndex = responseData.indexOf("access_token") + 16;
    const expiresInIndex = responseData.indexOf("expires_in") - 6;
    const accessToken = responseData.substring(
      accessTokenIndex,
      expiresInIndex,
    );
    //console.log("\nin JNSTools, " + new Date().toLocaleString() + ", accessToken: " + accessToken,);

    /*this.upload(file, accessToken);
  }

  static async upload(file, accessToken) { */
    const returnVal = await this.gd_uploadFile(
      name,
      type,
      file,
      function () {
        console.log();
      },
      accessToken,
    );

    return returnVal;
  }
  static async gd_uploadFile(name, contentType, data, callback, accessToken) {
    const boundary = "-------314159265358979323846";
    const delimiter = "\r\n--" + boundary + "\r\n";
    const close_delim = "\r\n--" + boundary + "--";

    contentType = contentType || "text/html";
    var metadata = {
      name: name,
      mimeType: contentType,
      parents: ["1hPYC5WM6HV6_Q5prfAAWZDacJzzsNCAd"],
    };

    var multipartRequestBody =
      delimiter +
      "Content-Type: application/json\r\n\r\n" +
      JSON.stringify(metadata) +
      delimiter +
      "Content-Type: " +
      contentType +
      "\r\n";

    //Transfer images as base64 string.
    //if (contentType.indexOf("image/") === 0) {
    var pos = data.indexOf("base64,");
    multipartRequestBody +=
      "Content-Transfer-Encoding: base64\r\n" +
      "\r\n" +
      data.slice(pos < 0 ? 0 : pos + "base64,".length);
    /*} else {
      multipartRequestBody += +"\r\n" + data;
    }*/
    multipartRequestBody += close_delim;

    if (!callback) {
      callback = function (file) {
        console.log("Update Complete ", file);
      };
    }

    const fetchResponse = await fetch(
      "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart",
      {
        method: "POST",
        headers: {
          "Content-Type": 'multipart/form-data;  boundary="' + boundary + '"',
          Authorization: "Bearer " + accessToken,
        },
        body: multipartRequestBody,
      },
      /*.set("Content-Type", 'multipart/form-data;  boundary="' + boundary + '"')
      .set("Authorization", "Bearer " + gapi.auth.getToken().access_token)
      .send(multipartRequestBody)
      .end(function () {
        console.log(arguments);
      });*/
    );
    const response = await fetchResponse.json();
    return response;
    /*      .then((response) => response.json())
      .then((data) => {
        return data;
      });*/
  }
  static async queryChatGPTOrig(query, refData) {
    const apiKey = "sk-proj-nd0RnhCy7wgMldtZxnpdT3BlbkFJKg1xC2rV0tFKcCtte48z";
    const url = "https://api.openai.com/v1/chat/completions";
    //console.log(typeof refData);
    const headers = {
      Authorization: "Bearer " + apiKey,
      "Content-Type": "application/json",
    };

    const conversationArrayString = sessionStorage.getItem("aiMessageHistory");
    const conversationArray = conversationArrayString
      ? JSON.parse(conversationArrayString)
      : [];

    conversationArray.push({
      role: "user",
      content: query,
    });

    const conversationPlusData = [
      {
        role: "user",
        content: typeof refData == "string" ? refData : JSON.stringify(refData),
      },
      ...conversationArray,
    ];

    conversationPlusData.unshift({
      role: "system",
      content:
        "You are a helpful assistant." +
        "You will be provided data from the SuiteProjects Pro professional services automation tool.  " +
        //"You are a rude assistant that uses lots of clever insults." +
        "You will answer questions about that data. " +
        "Data between two delimiters of :::project::: is project data.  " +
        "Data between two :::task::: delimiters is task data.  " +
        "Data between two :::raid items::: delimiters is data about risks, assumptions, issues, and decisions.  The issue_category_id on that table identifies which type of data the record is.    " +
        "Data between two :::requirements::: delimiters is data about requirements.  The oada_req_approvals__c field on that table identifies who needs to approve the requirement.  The oada_req_acknowledgements__c field on that table identifies who needs to acknowledge the requirement." +
        "Today's date is " +
        new Date().toISOString(),
    });

    const data = {
      model: "gpt-3.5-turbo", // You can use "gpt-3.5-turbo" or other models as needed
      messages: conversationPlusData,
      //max_tokens: 50,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      });

      const jsonData = await response.json();
      const aiResponse = jsonData.choices[0].message.content;

      conversationArray.push({
        role: "assistant",
        content: aiResponse,
      });
      sessionStorage.setItem(
        "aiMessageHistory",
        JSON.stringify(conversationArray),
      );
      return conversationArray;
    } catch (error) {
      console.error("Error calling the OpenAI API:", error);
      return "Failed to get response from ChatGPT.";
    }
  }
  static async queryChatGPT(query, refData, mode, assistantId) {
    const apiKey = "sk-proj-nd0RnhCy7wgMldtZxnpdT3BlbkFJKg1xC2rV0tFKcCtte48z";
    const url = "https://api.openai.com/v1/threads";
    const openaiHeaders = {
      Authorization: "Bearer " + apiKey,
      "Content-Type": "application/json",
      "OpenAI-Beta": "assistants=v2",
    };
    let currentThreadId = sessionStorage.getItem("currentAIThreadId");
    let currentThreadMessageList;

    if (!currentThreadId || mode == "solo") {
      const createThreadBody = {
        tool_resources: {
          file_search: {
            vector_store_ids: ["vs_0PYZVUNClN33CzMVryq5UNDZ"],
          },
        },
      };

      const createThreadResponse = await fetch(url, {
        method: "POST",
        headers: openaiHeaders,
        body: JSON.stringify(createThreadBody),
      });
      const responseData = await createThreadResponse.json();
      currentThreadId = responseData.id;
      if (mode != "solo") {
        sessionStorage.setItem("currentAIThreadId", responseData.id);
      }

      // you don't use system role, this API doesn't use it.  put instructions into the assistant config web page instead
      const dataBody = {
        role: "user",
        content: typeof refData == "string" ? refData : JSON.stringify(refData),
      };

      const postDataResp = await fetch(
        url + "/" + currentThreadId + "/messages",
        {
          method: "POST",
          headers: openaiHeaders,
          body: JSON.stringify(dataBody),
        },
      );

      /*
      const currentThreadResponse = await fetch(
        url + "/" + responseData.id + "/messages",
        {
          method: "GET",
          headers: openaiHeaders,
        },
      );

      currentThread = await currentThreadResponse.json();
      */
    }

    const queryBody = {
      role: "user",
      content: query,
    };

    // add user query to thread's message list
    const queryDataResponse = await fetch(
      url + "/" + currentThreadId + "/messages",
      {
        method: "POST",
        headers: openaiHeaders,
        body: JSON.stringify(queryBody),
      },
    );

    const assistantBody = {
      assistant_id: assistantId || "asst_1FDwykqPbVTBrBz9L0WaVROo",
    };

    //    try {
    // run query
    const response = await fetch(url + "/" + currentThreadId + "/runs", {
      method: "POST",
      headers: openaiHeaders,
      body: JSON.stringify(assistantBody),
    });

    const runJsonData = await response.json();
    //const aiResponse = jsonData.choices[0].message.content;
    const runId = runJsonData.id;

    let brakes = 0;
    let runStatus = runJsonData.status;

    let runJsonObject;
    while (
      (runStatus == "queued" || runStatus == "in_progress") &&
      brakes < 10000
    ) {
      brakes++;
      const runObject = await fetch(
        url + "/" + currentThreadId + "/runs/" + runId,
        {
          method: "GET",
          headers: openaiHeaders,
        },
      );
      runJsonObject = await runObject.json();
      runStatus = runJsonObject.status;
    }

    if (runStatus == "requires_action") {
      const toolCalls =
        runJsonObject.required_action.submit_tool_outputs.tool_calls;

      for (const toolCall of toolCalls) {
        let functionResponse;
        //const functionName = toolCall.function.name;
        //const functionToCall = availableFunctions[functionName];
        //const functionArgs = JSON.parse(toolCall.function.arguments);

        if (toolCall.function.name == "displayRandonNumber") {
          functionResponse = this.displayRandomNumber();
        }

        if (toolCall.function.name == "getCurrentDate") {
          functionResponse = new Date().toString();
        }

        const submitObject = {
          tool_outputs: [
            {
              tool_call_id: toolCall.id,
              output: functionResponse,
            },
          ],
        };
        const submitObjectsResponse = await fetch(
          url +
            "/" +
            currentThreadId +
            "/runs/" +
            runJsonObject.id +
            "/submit_tool_outputs",
          {
            method: "POST",
            headers: openaiHeaders,
            body: JSON.stringify(submitObject),
          },
        );

        /*messages.push({
          tool_call_id: toolCall.id,
          role: "tool",
          name: functionName,
          content: functionResponse,
        }); // extend conversation with function response*/
      }
    }

    const currentThreadResponse = await fetch(
      url + "/" + currentThreadId + "/messages",
      {
        method: "GET",
        headers: openaiHeaders,
      },
    );

    currentThreadMessageList = await currentThreadResponse.json();
    const dataMinusRefData = currentThreadMessageList.data;
    dataMinusRefData.pop();

    const returnArray = [];
    dataMinusRefData.forEach((elem) =>
      returnArray.push({
        role: elem.role,
        content: elem.content[0].text.value,
      }),
    );

    return returnArray;
    //    } catch (error) {
    //      console.error("Error calling the OpenAI API:", error);
    //      return "Failed to get response from ChatGPT.";
    //    }
  }
  static getExtensionIcon(extension) {
    let typeIconSrc;
    switch (extension) {
      case "m4a":
      case "flac":
      case "mp3":
      case "wav":
      case "wma":
      case "aac":
        typeIconSrc = "audio_icon.png";
        break;
      case "xlsx":
      case "xlsm":
      case "xlsb":
      case "xltx":
      case "xltm":
      case ".xls":
      case ".xlt":
        typeIconSrc = "msexcel_icon.png";
        break;
      case "pptx":
      case "pptm":
      case "potx":
      case "potm":
      case "ppsx":
      case "ppsm":
      case "ppam":
        typeIconSrc = "mspowerpoint_icon.png";
        break;
      case "doc":
      case "docm":
      case "dot":
      case "dotm":
      case "dotx":
      case "docx":
        typeIconSrc = "msword_icon.png";
        break;
      case "pdf":
        typeIconSrc = "pdf_icon.png";
        break;
      case "txt":
      case "rtf":
      case "log":
      case "xml":
      case "json":
      case "js":
      case "php":
      case "py":
        typeIconSrc = "text_icon.png";
        break;
      case "mp4":
      case "avi":
      case "mov":
      case "wmv":
      case "mkv":
      case "flv":
        typeIconSrc = "video_icon.png";
        break;
      default:
        typeIconSrc = "blank_icon.png";
        break;
    }
    return typeIconSrc;
  }
  static displayRandomNumber() {
    return "rand: " + Math.random();
  }
  static valueFromId(id, table, creds) {
    let returnValue;
    const tableStringFromStorage = localStorage.getItem(
      creds.company + "|" + table,
    );
    if (tableStringFromStorage) {
      const tableFromStorage = JSON.parse(tableStringFromStorage);
      const tableRecord = tableFromStorage.find((elem) => elem.id == id);
      if (tableRecord) {
        returnValue = tableRecord.name;
      }
    }
    return returnValue;
  }
  static async dbRead(table, keys) {
    const client = new AWS.DynamoDB.DocumentClient({
      region: "us-east-1",
      accessKeyId: "AKIA4FSYGPH37CDTBOO7",
      secretAccessKey: "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",
    });

    // Get item from DynamoDB
    const params = {
      TableName: table,
      Key: keys,
    };

    const result = await client.get(params).promise();

    return result.Item;
  }
  static async dbQuery(table, index, expression, values) {
    const client = new AWS.DynamoDB.DocumentClient({
      region: "us-east-1",
      accessKeyId: "AKIA4FSYGPH37CDTBOO7",
      secretAccessKey: "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",
    });

    // Get item from DynamoDB
    const params = {
      TableName: table,
      IndexName: index,
      KeyConditionExpression: expression,
      ExpressionAttributeValues: values,
    };

    const result = await client.query(params).promise();

    return result.Items;
  }
  static async dbWrite(table, record) {
    const client = new AWS.DynamoDB.DocumentClient({
      region: "us-east-1",
      accessKeyId: "AKIA4FSYGPH37CDTBOO7",
      secretAccessKey: "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",
    });

    // Put item into DynamoDB
    const params = {
      TableName: table,
      Item: record,
    };

    //client.put(params).promise();
    const result = await client.put(params).promise();

    return result;
  }
  static async getNewsfeedId(projId, creds) {
    const authString = this.getXmlBodyAuthString(creds);
    const urlString = this.getInstanceUrl(creds);
    let newsfeedId = 0;
    const newsfeedRequestString =
      authString +
      '<Read type="NewsfeedMessage" method="equal to" limit="1" enable_custom="1"><NewsfeedMessage><<_Return><newsfeedid/></_Return></Read></request>';
    const newsfeedXML = await this.fetchPost(
      newsfeedRequestString,
      urlString,
      "NewsfeedMessage",
    );
    if (newsfeedXML.xml.length > 0) {
      const newsfeedArray = this.xmlToArray(newsfeedXML.xml);
      newsfeedId = newsfeedArray[0].newsfeedid;
      return newsfeedId;
    } else {
      const newsfeedAddString =
        authString + '<Add type="Newsfeed"></Add></request>';
      const addNewsfeedXML = await this.fetchPost(
        newsfeedAddString,
        urlString,
        "Newsfeed",
      );
      if (addNewsfeedXML.xml.length > 0) {
        const addNewsfeedArray = this.xmlToArray(addNewsfeedXML.xml);
        newsfeedId = addNewsfeedArray[0].newsfeedid;
        return newsfeedId;
      }
    }
  }
  static switchNames(origName, delim) {
    const commaPosition = origName.indexOf(",");
    let newName;
    let newDelim;
    if (commaPosition > 0) {
      let newDelim;
      if (!delim) {
        newDelim = "";
      } else {
        newDelim = delim;
      }
      const beforeComma = origName.substring(0, commaPosition).trim();
      const afterComma = origName.substring(commaPosition + 1).trim();
      newName = afterComma + newDelim + beforeComma;
    } else {
      newName = origName;
    }

    return newName;
  }
}

export default JNSTools;
